(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-app-connect"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Botón «Descargar»: Android → Google Play, iPhone/iPad → App Store; en ordenador, su enlace
    const ua = navigator.userAgent || '';
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const apply = (root) => {
      root.querySelectorAll('[data-sfac-smart]').forEach((a) => {
        const url = isAndroid ? a.dataset.android : isIOS ? a.dataset.ios : '';
        if (url) a.href = url;
      });
    };
    apply(document);
    document.addEventListener('shopify:section:load', (e) => apply(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-carrusel-tarjetas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sf-card-carousel')) return;

    class SfCardCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sfct__track');
        this.prev = this.querySelector('.sfct__arrow--prev');
        this.next = this.querySelector('.sfct__arrow--next');
        this.thumb = this.querySelector('.sfct__thumb');
        if (!this.track) return;

        this.onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = null; this.update(); }); };
        this.onClick = (e) => this.go(Number(e.currentTarget.dataset.dir));
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        [this.prev, this.next].forEach((b) => b && b.addEventListener('click', this.onClick));
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.ro) this.ro.disconnect();
      }

      step() {
        const card = this.track.querySelector('.sfct-card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      scrollToCard(card) {
        if (!card) return;
        const pad = parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft - pad, behavior: 'auto' });
      }

      update() {
        const t = this.track;
        this.style.setProperty('--sfct-sbw', (window.innerWidth - document.documentElement.clientWidth) + 'px');
        const max = t.scrollWidth - t.clientWidth;
        const x = Math.max(0, Math.min(t.scrollLeft, max));
        if (this.prev) this.prev.hidden = x <= 2;
        if (this.next) this.next.hidden = x >= max - 2;
        if (this.thumb) {
          const ratio = max > 0 ? t.clientWidth / t.scrollWidth : 1;
          const thumbPct = Math.max(ratio * 100, 15);
          const progress = max > 0 ? x / max : 0;
          this.style.setProperty('--sfct-thumb', thumbPct + '%');
          // translateX en % del propio tramo: recorrido = (100 - ancho) / ancho
          this.style.setProperty('--sfct-x', (progress * (100 - thumbPct) / thumbPct * 100) + '%');
          this.thumb.parentElement.hidden = max <= 0;
        }
      }
    }
    customElements.define('sf-card-carousel', SfCardCarousel);

    // Editor: al seleccionar una tarjeta, se desliza hasta ella
    document.addEventListener('shopify:block:select', (e) => {
      const card = e.target.closest && e.target.closest('.sfct-card');
      const carousel = card && card.closest('sf-card-carousel');
      if (carousel && carousel.scrollToCard) carousel.scrollToCard(card);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
